
import { v4 as uuidv4 } from "uuid";
import {
  RollPlusUpgradable, UpgradableNumber
} from "@dndModels";

export class CreateResourceOption {
  true_id = "";
  resource_type = "Slot";
  // _id of the source of the ResourceFeature giving resource_type,
  // if it's different from the source of the feature creating it.
  resource_source_id = "";
  level = "1";
  slot_type = "Any";
  amount: RollPlusUpgradable = new RollPlusUpgradable(1);
  up_to_max: UpgradableNumber = new UpgradableNumber();
  
  required_level = 1;
  
  constructor(obj?: any) {
    this.true_id = obj ? obj.true_id : uuidv4().toString();
    if (obj) {
      this.resource_type = obj.resource_type ? obj.resource_type : "Slot"; 
      this.resource_source_id = obj.resource_source_id ? obj.resource_source_id : "";
      this.level = obj.level ? `${obj.level}` : "1";
      this.slot_type = obj.slot_type ? obj.slot_type : "Any";
      this.amount = obj.amount ? new RollPlusUpgradable(obj.amount) : new RollPlusUpgradable(1);
      this.up_to_max = obj.up_to_max ? new UpgradableNumber(obj.up_to_max) : new UpgradableNumber();
      this.required_level = obj.required_level ? obj.required_level : 1;
    }
  }

  toDBObj(): any {
    return {
      true_id: this.true_id,
      resource_type: this.resource_type,
      resource_source_id: this.resource_source_id,
      level: this.level,
      slot_type: this.slot_type,
      amount: this.amount.toDBObj(),
      up_to_max: this.up_to_max.toDBObj(),
      required_level: this.required_level
    };
  }

  copy(copyMe: CreateResourceOption, drop_ids = false) {
    if (!drop_ids) {
      this.true_id = copyMe.true_id;
    }
    this.slot_type = copyMe.slot_type;
    this.amount = copyMe.amount.clone();
    this.up_to_max = copyMe.up_to_max.clone();
    this.level = copyMe.level;
    this.required_level = copyMe.required_level;
    this.resource_type = copyMe.resource_type;
    this.resource_source_id = copyMe.resource_source_id;
  }

  clone() {
    const new_obj = new CreateResourceOption();
    new_obj.copy(this);
    return new_obj;
  }
}

export class CreateItemOption {
  true_id = "";
  item_creation_type: "Knowledge" | "Specific" | "Selectable" = "Knowledge";
  knowledge_key = ""; // If Knowledge, then this is the Knowledge Key it looks at
  required_tags: string[] = []; // If Knowledge, this is a filter on the Knowledge found with the key.
  base_item_ids: string[] = []; // If Specific then this list contains all the options
  rarities: number[] = [];
  create_at_level = 1;
  amount: RollPlusUpgradable = new RollPlusUpgradable(1);
  
  constructor(obj?: any) {
    this.true_id = obj ? obj.true_id : uuidv4().toString();
    if (obj) {
      this.item_creation_type = obj.item_creation_type ? obj.item_creation_type : "Knowledge";
      this.knowledge_key = obj.knowledge_key ? obj.knowledge_key : "";
      this.required_tags = obj.required_tags ? obj.required_tags : [];
      this.base_item_ids = obj.base_item_ids ? obj.base_item_ids : []; 
      this.rarities = obj.rarities ? obj.rarities : [];
      this.create_at_level = obj.create_at_level ? obj.create_at_level : 1;
      this.amount = obj.amount ? new RollPlusUpgradable(obj.amount) : new RollPlusUpgradable(1);
    }
  }

  get pseudo_item_ids(): string[] {
    return this.base_item_ids.map(o => `B:${o}`);
  }
 
  toDBObj(): any {
    return {
      true_id: this.true_id,
      item_creation_type: this.item_creation_type,
      knowledge_key: this.knowledge_key,
      required_tags: this.required_tags,
      base_item_ids: this.base_item_ids,
      rarities: this.rarities,
      create_at_level: this.create_at_level,
      amount: this.amount.toDBObj(),
    };
  }

  copy(copyMe: CreateItemOption, drop_ids = false) {
    if (!drop_ids) {
      this.true_id = copyMe.true_id;
    }
    this.item_creation_type = copyMe.item_creation_type;
    this.knowledge_key = copyMe.knowledge_key;
    this.required_tags = [...copyMe.required_tags];
    this.base_item_ids = [...copyMe.base_item_ids];
    this.rarities = [...copyMe.rarities];
    this.create_at_level = copyMe.create_at_level;
    this.amount = copyMe.amount.clone();
  }

  clone() {
    const new_obj = new CreateItemOption();
    new_obj.copy(this);
    return new_obj;
  }
}